import { makeStyles } from "@material-ui/core";

export default makeStyles((theme) => ({
  root: {},
  avatarWrapper: {
    height: "55px",
    marginLeft: "36px",
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    "& .MuiAvatar-root": {
      width: "40px",
      height: "40px",
      borderRadius: theme.spacing(6),
      margin: 0,
      backgroundColor: theme.palette.red2.main,
    },
  },
  menuItems: {
    borderRadius: "8px",
    padding: "12px",
    width: theme.spacing(60),
  },
  noHover: {
    cursor: "default",
    "&:hover": {
      backgroundColor: "transparent !important",
    },
  },
  twoTxt: {
    marginRight: theme.spacing(2),
  },
  wrapperPlan: {
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
  },
  plan: {},
  authentication: {},
  exit: {
    color: theme.palette.red.main,
  },
  container: {
    display: "flex",
    alignItems: "flex-end",
    height: "100%",
  },
  menuItem: {
    paddingLeft: "0px",
    borderRadius: "4px",
    backgroundColor: theme.palette.white.main,
    "&:hover": {
      backgroundColor: theme.palette.red2.tint12,
      color: theme.palette.red2.main,
    },
  },
  icon: {
    color: theme.palette.red.main,
    margin: theme.spacing(0, 2),
  },
  avatarArrow: {
    margin: "auto 0px auto 12px",
    "& i": {
      color: theme.palette.secondary.main,
    },
  },
  Exit: {
    padding: theme.spacing(6),
    borderRadius: theme.spacing(2),
  },
  title: {
    padding: "12px 12px 14px",
    borderRadius: theme.spacing(2),
    backgroundColor:
      theme.palette.type === "light"
        ? theme.palette.secondary.tint100
        : theme.palette.secondary.tint90,
    "& p": {
      lineHeight: 1.83,
      textAlign: "right",
    },
    "& span:nth-child(1)": {
      lineHeight: 1.71,
      textAlign: "right",
      float: "inline-end",
    },
    "& span:nth-child(2)": {
      lineHeight: 1.5,
      fontFamily: "iranyekanBold !important",
      textAlign: "left",
    },
  },
  btn: {
    width: "100%",
    display: "block",
    margin: "3px 0px",
    padding: "12px 10px 12px 12px",
    opacity: 0.7,
    borderRadius: "4px;",
    textAlign: "left",
    "& .MuiButton-label": {
      color: theme.palette.secondary.main,
      lineHeight: "24px",
      alignItems: "center",
      display: "inline-flex",
      "& i:first-child": {
        color: theme.palette.secondary.tint15,
        float: "right",
        fontSize: "14px",
        lineHeight: 1.71,
      },
      "& span:nth-child(2)": {
        width: "100%",
      },
      "& i:nth-child(3)": {
        color: theme.palette.secondary.tint15,
        marginRight: "8px",
        fontSize: "18px",
        lineHeight: 1.71,
      },
    },
    "&:hover": {
      opacity: 0.6,
      backgroundColor: [theme.palette.background.main, "!important"],
      color: theme.palette.secondary.main,
      "& .MuiButton-label": {
        color: theme.palette.secondary.main,
        "& i:first-child": {
          color: theme.palette.secondary.tint40,
        },
        "& i:nth-child(3)": {
          color: theme.palette.secondary.main,
        },
      },
    },
  },

  Buttons: {
    marginTop: "24px",
    minWidth: "263px",
    display: "inline-flex",
  },
  headerBtn: {
    padding: "3px 5px 3px 3px",
    borderRadius: "8px",
    fontSize: "12px",
  },
  wallets: {
    marginRight: "36px",
  },
  withdraw: {
    margin: "0px 6px",
    textAlign: "center",
    backgroundColor:
      theme.palette.type === "light"
        ? [theme.palette.red2.tint12, "!important"]
        : [theme.palette.red2.main, "!important"],
    color: [theme.palette.secondary.main, "!important"],
  },
  dapasit: {
    textAlign: "center",
  },
  nullBtn: {
    display: "none",
  },
  signOut: {
    margin: "6px 10px",
    padding: "12px 10px 12px 12px",
    float: "left",
    color: theme.palette.secondary.tint40,
    "& i": {
      marginRight: "8px",
    },
    "&:hover": {
      backgroundColor: theme.palette.red2.tint12,
      color: theme.palette.red2.main,
    },
  },
  Menu: {
    borderBottomWidth: "thin",
    borderBottomColor: "rgba(218, 220, 226, 0.5)",
    borderBottomStyle: "solid",
  },
}));
